import styles from "./DotPulse.module.css";

interface DotPulseProps {
    options: {
        color: string;
    };
}

export const DotPulse = ({ options }: DotPulseProps) => {
    return (
        <div className="flex bg-white dark:bg-darkSurface-200">
            <div className={`w-4 h-4 rounded-full ${styles.firstDot}`} style={{ backgroundColor: options.color }}></div>
            <div
                className={`w-4 h-4 rounded-full ${styles.secondDot}`}
                style={{ backgroundColor: options.color }}
            ></div>
            <div className={`w-4 h-4 rounded-full ${styles.thirdDot}`} style={{ backgroundColor: options.color }}></div>
        </div>
    );
};
